import { _ } from "~/i18n";
import { createPremiumIcon, icon, node } from "~/util/dom";
import { openPremiumOnboarding } from "~/util/user-note";

export type TUserButtonType = "default" | "detail" | "edit" | "remove";

interface IUserNote {
	type?: TUserButtonType;
	isPremiumUser?: boolean;
	onClick?: () => void;
}

// tlacitko - upravit / pridat poznamku
export function createUserNoteBtn({
	type = "default",
	isPremiumUser = false,
	onClick = () => {},
}: IUserNote) {
	const mainClassess = [];

	if (type !== "default") {
		mainClassess.push(`type-${type}`);
	}

	const container = node("button", { type: "button", className: `user-note-btn ${mainClassess.join(" ")}` });

	if (type === "remove") {
		container.append(icon("delete2"));
	} else {
		const isEdit = type === "edit";
		const text = node("span", { className: "user-note-btn__text", textContent: isEdit ? _("note.editNote") : _("note.addNote") });

		if (isEdit && !isPremiumUser) {
			container.append(createPremiumIcon(), text);
		} else {
			container.append(icon(isEdit ? "edit2" : "edit-note"), text);
		}

		if (!isPremiumUser && !isEdit) {
			container.append(createPremiumIcon());
		}
	}

	container.setAttribute("data-log-action", "MyMapsNotes_premiumPurchase_show");
	container.addEventListener("click", () => {
		if (isPremiumUser) {
			onClick();
		} else {
			openPremiumOnboarding();
		}
	});

	return container;
}
